import { useTranslation } from 'react-i18next';
import { useTheme } from 'next-themes';
import { Button } from '@pps/ui/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ArrowUpCircle, MoreVertical } from 'lucide-react';
import { LANGUAGES } from '@/components/LanguageToggle';

const THEMES = ['light', 'dark', 'system'] as const;

/**
 * Entrada MOBILE de idioma, tema e "Alterar plano".
 *
 * Motivo de existir: no header (`AppLayout.tsx`) esses tres controles viviam
 * num `hidden md:flex` e sumiam abaixo de 768px — e `LanguageToggle` /
 * `ThemeToggle` nao tinham nenhuma outra entrada no app. Resultado em campo
 * (Arena 015, 19/08/2026): do tablet da recepcao nao dava para trocar idioma
 * nem ligar o modo escuro. "Alterar plano" ainda era alcancavel de raspao
 * pelo `PlanGate`, mas so ao esbarrar numa feature bloqueada.
 *
 * Itens PLANOS (label de secao + itens), nao submenu: submenu do Radix e
 * orientado a hover e fica ruim no toque, que e exatamente o alvo aqui.
 */
interface HeaderOverflowMenuProps {
  onOpenPlanUpgrade: () => void;
}

export function HeaderOverflowMenu({ onOpenPlanUpgrade }: HeaderOverflowMenuProps) {
  const { t, i18n } = useTranslation();
  const { setTheme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8" aria-label={t('common.moreOptions')}>
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{t('common.language')}</DropdownMenuLabel>
        {LANGUAGES.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            className={i18n.language === lang.code ? 'bg-accent' : ''}
          >
            {lang.label}
          </DropdownMenuItem>
        ))}

        <DropdownMenuSeparator />

        <DropdownMenuLabel>{t('common.theme')}</DropdownMenuLabel>
        {THEMES.map((mode) => (
          <DropdownMenuItem key={mode} onClick={() => setTheme(mode)}>
            {t(`theme.${mode}`)}
          </DropdownMenuItem>
        ))}

        <DropdownMenuSeparator />

        <DropdownMenuItem onClick={onOpenPlanUpgrade} className="gap-2">
          <ArrowUpCircle className="h-3.5 w-3.5" />
          {t('common.changePlan')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
